import { clsx } from 'clsx';
import { Text } from '@ubnt/ui-components/aria/Typography/Text';
import { Flex } from 'components/Flex';
import VisibleWithMouse from 'components/VisibleWithMouse';
import { CoverageLegendThumb } from 'modules/editor/components/CoverageLegend/CoverageLegendThumb';
import { gradientStyle } from 'modules/editor/components/CoverageLegend/utils';

import classes from 'modules/editor/components/CoverageLegend/CoverageLegend.module.scss';
import { useApplicationStore } from 'modules/application/store';

interface Props {
  className: string;
}

export function CoverageLegend(props: Props) {
  const isLargeScreen = useApplicationStore((state) => !state.isMobile);

  return (
    <Flex className={clsx(classes.CoverageLegend, props.className)} gap="s">
      <Text weight="bold" size="xsmall">
        Weak
      </Text>
      <Flex className={classes.middle} alignBaseline style={gradientStyle}>
        {isLargeScreen && (
          <VisibleWithMouse>
            <CoverageLegendThumb />
          </VisibleWithMouse>
        )}
      </Flex>
      <Text weight="bold" size="xsmall">
        Strong
      </Text>
    </Flex>
  );
}
